export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/dashboard.worker.b5cc2487.worker.js");
}
